import React from "react";
import Footer from "../components/Footer";
import "./AboutUs.css";
const Contact = () => {
  return (
    <div style={{ height: "90vh" }}>
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h1 className="section-title">
          Reach out for any medical services at your convenience.
        </h1>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
